export const firebaseConfig = {
  apiKey: "AIzaSyAGuazAJOwpxcp2t3Du_WBP99kzH3XuY6U",
  authDomain: "control-2-tucasa.firebaseapp.com",
  projectId: "control-2-tucasa",
  storageBucket: "control-2-tucasa.appspot.com",
  messagingSenderId: "714579953227",
  appId: "1:714579953227:web:a4ef5ffab1683b6d9f2fce",
  measurementId: "G-1YSLVXGN62"
};
